import { Injectable, inject } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { map, catchError, switchMap } from "rxjs/operators";
import { of } from "rxjs";
import {
	FeatureFlagsActionTypes,
	LoadFeatureFlagsAction,
	LoadFeatureFlagsSuccessAction,
	LoadFeatureFlagsFailureAction,
} from "./feature-flags.actions";
import { FeatureFlagsService } from "../services/feature-flags.lib.service";

@Injectable({
	providedIn: "root",
})
export class FeatureFlagsEffects {
	private actions$ = inject(Actions);
	private featureFlagsService = inject(FeatureFlagsService);

	loadFeatureFlags$ = createEffect(() =>
		this.actions$.pipe(
			ofType<LoadFeatureFlagsAction>(FeatureFlagsActionTypes.LoadFeatureFlags),
			switchMap(() =>
				this.featureFlagsService.fetchFeatureFlags().pipe(
					map((flags) => new LoadFeatureFlagsSuccessAction(flags)),
					catchError((error) =>
						of(new LoadFeatureFlagsFailureAction(error.message || "Failed to load feature flags"))
					)
				)
			)
		)
	);
}
